var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$fetchState.pending)?_c('Loading'):_c('ResourceTable',{attrs:{"schema":_vm.schema,"rows":_vm.rows}})}
var staticRenderFns = []

export { render, staticRenderFns }